var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filter-header'),_c('v-container',{attrs:{"grid-list-md":""}},[_c('date-filter'),_c('br'),_c('others')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }